import { AgeCategory } from '@mews-commander/data-access';

export const isDefaultAgeCategoryForService = (serviceId: string | undefined) => (ageCategory: AgeCategory) =>
    ageCategory.isDefault && ageCategory.serviceId === serviceId;
